// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"968adb30","286":"968adb30","514":"87412972","517":"b7e550ed","555":"393e4b63","646":"2959b1f3","667":"968adb30","905":"968adb30","936":"9d4cde1d","942":"58a6aa10"}[chunkId] + ".chunk.css";
};